import axios from '@/plugins/axios';

export async function upload(work_space, organization, data){
    return await axios.post(`work-spaces/${work_space}/organizations/${organization}/house-person-debtor-uploads/upload`, data);
}

export async function getTemplate(work_space, organization){
    return await axios.get(`work-spaces/${work_space}/organizations/${organization}/house-person-debtor-uploads/template`, {responseType: 'blob'});
}

export async function getUpload(work_space, organization, id){
    return await axios.get(`work-spaces/${work_space}/organizations/${organization}/house-person-debtor-uploads/${id}`);
}

export async function execute(work_space, organization, id, data){
    return await axios.post(`work-spaces/${work_space}/organizations/${organization}/house-person-debtor-uploads/${id}/execute`, data);
}

export async function normalize(work_space, organization, id){
    return await axios.post(`work-spaces/${work_space}/organizations/${organization}/house-person-debtor-uploads/${id}/normalize`);
}

export async function identifyHouseAddress(work_space, organization, id){
    return await axios.post(`work-spaces/${work_space}/organizations/${organization}/house-person-debtor-uploads/${id}/identify-house-address`);
}